/* global _TL_ */
import Backbone from 'backbone';
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'react-jss';
import { getBudgetRange, MinXandrDailyBudgetRangePerCurrency } from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { BudgetSuggestionDialog } from '@bingads-webui-campaign-react/budget-suggestion-v2';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { Scenario, Activity } from '@bingads-webui-react/hoc-with-signal';
import { isXandrServing } from '@bingads-webui-campaign-react/constants';

export class BudgetSuggestionContainer extends Backbone.View {
  initialize({
    scope,
    campaignId,
    serverContext,
    i18n,
    CustomerId,
    AcctId,
    currency,
    budget,
    activity,
    campaign,
    grid,
    instrumentation,
  }) {
    this.scope = scope;
    this.campaignId = campaignId;
    this.serverContext = serverContext;
    this.i18n = i18n;
    this.currency = currency;
    this.CustomerId = CustomerId;
    this.AcctId = AcctId;
    this.budget = budget;
    this.parentRemove = super.remove;
    this.activity = activity;
    this.scenario = 'Edit-DisplayAds';
    this.campaign = campaign;
    this.grid = grid;
    this.instrumentation = instrumentation;
    this.showDialog = true;
    this.budgetRange = getBudgetRange(this.currency);

    if (campaign.Budget.Type === 'Monthly') {
      this.minBudget = this.budgetRange.Monthly.Min;
      this.maxBudget = this.budgetRange.Monthly.Max;
    } else {
      this.IsDailyBudgt = true;
      this.minBudget = this.budgetRange.Daily.Min;
      this.maxBudget = this.budgetRange.Daily.Max;
    }

    const { CampaignSubType, CampaignSettings } = this.campaign;

    if (isXandrServing(CampaignSubType, CampaignSettings) && MinXandrDailyBudgetRangePerCurrency[this.currency]) {
      this.minBudget =  MinXandrDailyBudgetRangePerCurrency[this.currency];
    }

    this.render();
  }

  refreshGrid() {
    this.grid.gridView.refresh({force: true});
  }

  onTriggerDialog() {
    this.showDialog = !this.showDialog;
    this.render();
  }

  render() {
    const scenarioName = 'BudgetSuggestionEditing';
    const activityName = 'Grid';

    ReactDOM.render(
      <InstrumentationContext.Provider value={this.instrumentation}>
        <ThemeProvider theme={{ components: ComponentSettings, core: ThemeFluent }}>
          <FluentProvider theme={webLightTheme}>
            <I18nContext.Provider value={this.i18n}>
              <Scenario name={scenarioName}>
                <Activity name={activityName}>
                  <ScopeContext.Provider value={{ scope: { values: { cid: this.CustomerId, aid: this.AcctId } } }}>
                    <ServerContext.Provider value={this.serverContext}>
                      <BudgetSuggestionDialog
                        i18n={this.i18n}
                        campaignId={String(this.campaignId)}
                        campaignType={this.options.campaignType}
                        currency={this.currency}
                        budget={this.budget}
                        enableSaving={true}
                        campaign={this.campaign}
                        onGridRefresh={_.bind(this.refreshGrid, this)}
                        showDialog={this.showDialog}
                        onTriggerDialog={_.bind(this.onTriggerDialog, this)}
                        minBudget={this.minBudget}
                        maxBudget={this.maxBudget}
                      />
                    </ServerContext.Provider>
                  </ScopeContext.Provider>
                </Activity>
              </Scenario>
            </I18nContext.Provider>
          </FluentProvider>
        </ThemeProvider>
      </InstrumentationContext.Provider>
      ,
      this.el,
    );
    return this;
  }
}
